import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { DropdownItem } from 'reactstrap';
import { titleCase } from "../../helpers/formatting";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { isRxRoute } from "../../helpers/formatting";
import * as msgs from "../../constants/textConstants";
import TryAgainToolTip from '../common/TryAgainToolTip';

class PharmacyUsers extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.PharmacyUsers.ComponentDidMount", new Date(), Tools.getURLPath());
    }


    render() {
        const { list, activeUser, onUserSelected, history, orderRefillCompleted, rxTransferCompleted, rxDown } = this.props;
        const currentPath = history && history.location && history.location.pathname;
        const requestCompleted = (orderRefillCompleted && /rxrefill/.test(currentPath.toLowerCase())) || (rxTransferCompleted && /bswtransfer/.test(currentPath.toLowerCase()));
        const pathname = currentPath && isRxRoute(currentPath) && !requestCompleted ? currentPath : '/pharmacy';

        return (
            <div className="proxy-dropdown__rx">
                {list && list.length > 0 &&
                    <div>
                        <DropdownItem header  className={`${rxDown ? "disabled-style" : ""}`}>Family {msgs.PharmacyTileName} Accounts</DropdownItem>
                        {list.map((user, index) => activeUser && activeUser.pharmacyPatientId && activeUser.index === user.index
                            ? (!rxDown ?
                                <DropdownItem key={index}>
                                    {titleCase(user.firstName)} {titleCase(user.lastName)}
                                </DropdownItem> :
                                <React.Fragment>
                                    <TryAgainToolTip target={`pharmacyUser${index + 1}`} className="try-again-proxy-menu-tooltip" />
                                    <div id={`pharmacyUser${index+1}`}>
                                        <DropdownItem key={index} className="disabled-style">
                                            {titleCase(user.firstName)} {titleCase(user.lastName)}
                                        </DropdownItem> 
                                    </div>
                                </React.Fragment>
                              )
                            : (!rxDown ? 
                                <Link key={index} to={{ pathname: pathname }}>
                                    <DropdownItem onClick={() => onUserSelected(user)}>
                                        {titleCase(user.firstName)} {titleCase(user.lastName)}
                                    </DropdownItem>
                                </Link> : 
                                <React.Fragment>
                                    <TryAgainToolTip target={`pharmacyUser${index + 1}`} className="try-again-proxy-menu-tooltip" />
                                    <div id={`pharmacyUser${index+1}`}>
                                        <DropdownItem onClick={() => onUserSelected(user)} className="disabled-style">
                                            {titleCase(user.firstName)} {titleCase(user.lastName)}
                                        </DropdownItem>   
                                    </div>
                                </React.Fragment>                         
                            )
                        )}
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { submitOrderResult, transfer } = state.pharmacy;
    return {
        history: state.session.history,
        orderRefillCompleted: submitOrderResult && (submitOrderResult.SuccessRx || submitOrderResult.RenewedRx || submitOrderResult.FailuresRx),
        rxTransferCompleted: transfer && (transfer.error || transfer.result),
        rxDown: state.common.rxDown
    };
};

export default connect(mapStateToProps)(PharmacyUsers);